export default {
  LK: {
    pageTitle: "الحساب الشخصي",
    subscription: {
      yourSubs: "اشتراكك",
      plan_1: "مجاني",
      plan_2: "موسع",
      plan_3: "شخصي",
      changePlan: "تغيير الخطة",
      activeFor: "نشط حتى",
      nextPayment: "الدفع التالي",
      accessFor: "الوصول مفتوح حتى",
      expired: "انتهت",
    },
    eduSubs: "اشتراك تعليمي",
    settings: "الإعدادات",
    form: {
      labels: {
        status: "الحالة",
        spec_med: "التخصص",
        position: "الوظيفة",
        university: "الجامعة",
      },
      spec_statValues: {
        doctor: "طبيب",
        student: "طالب",
        resident: "مقيم",
        spec_med: "موظف في منشأة طبية",
      },
      spec_medValues: {
        Obstetrician: "طبيب توليد",
        "Obstetrician-gynecologist": "طبيب نسائية وتوليد",
        Allergist: "طبيب حساسية",
        Angiosurgeon: "جراح أوعية دموية",
        Andrologist: "طبيب أمراض الذكورة",
        Anesthetist: "طبيب تخدير",
        Anesthesiologist: "طبيب تخدير وإنعاش",
        Audiologist: "أخصائي سمعيات",
        Bacteriologist: "أخصائي بكتيريا",
        Venereologist: "أخصائي أمراض تناسلية",
        Vertebrologist: "أخصائي العمود الفقري",
        "Laboratory diagnostics doctor": "طبيب تشخيص مخبري",
        "Physiotherapy doctor": "طبيب علاج طبيعي",
        "Magnetic resonance imaging doctor": "طبيب تصوير بالرنين المغناطيسي",
        GP: "طبيب عام",
        "Sports medicine doctor": "طبيب طب رياضي",
        "Ultrasound diagnostic doctor": "طبيب تشخيص بالأمواج فوق الصوتية",
        "Functional diagnostics doctor": "طبيب تشخيص وظيفي",
        Dermatovenerologist: "أخصائي أمراض جلدية وتناسلية",
        Dermatologist: "طبيب أمراض جلدية",
        "Pediatric gastroenterologist": "طبيب جهاز هضمي للأطفال",
        "Pediatric gynecologist": "طبيب نسائية أطفال",
        "Pediatric cardiologist": "طبيب قلب أطفال",
        "Pediatric neurologist": "طبيب أعصاب أطفال",
        "Child psychiatrist": "طبيب نفسي أطفال",
        "Pediatric dentist": "طبيب أسنان أطفال",
        "Pediatric traumatologist-orthopedist": "طبيب عظام أطفال",
        "Pediatric urologist-andrologist": "طبيب مسالك بولية أطفال",
        "Pediatric surgeon": "جراح أطفال",
        "Pediatric endocrinologist": "طبيب غدد صماء أطفال",
        Nutritionist: "اختصاصي تغذية",
        "Other specialty": "تخصص آخر",
        Immunologist: "أخصائي مناعة",
        "Infectious disease specialist": "طبيب أمراض معدية",
        Cardiologist: "طبيب قلب",
        Kinesiotherapist: "معالج حركي",
        "Clinical Pharmacologist": "اختصاصي أدوية سريرية",
        Coloproctologist: "أخصائي أمراض القولون والمستقيم",
        Cosmetologist: "خبير تجميل",
        "Laboratory assistant": "فني مخبري",
        "Speech therapist": "أخصائي نطق",
        "ENT (Otorhinolaryngologist)": "طبيب أنف وأذن وحنجرة",
        Mammologist: "طبيب ثدي",
        Chiropractor: "معالج تقويم يدوي",
        Masseur: "مدلك",
        Nurse: "ممرضة",
        "Medical brother": "ممرض",
        "Medical Director": "المدير الطبي",
        Mycologist: "أخصائي فطريات",
        "Expert in narcology": "اختصاصي إدمان",
        Neurologist: "طبيب أعصاب",
        Neurophysiologist: "أخصائي فيزيولوجيا الأعصاب",
        Neurosurgeon: "جراح أعصاب",
        Neonatologist: "طبيب حديثي الولادة",
        Nephrologist: "طبيب كلى",
        "Oculist (Ophthalmologist)": "طبيب عيون",
        Oncologist: "طبيب أورام",
        Orthopedist: "طبيب عظام",
        Osteopath: "اختصاصي علاج عظام",
        Parasitologist: "اختصاصي طفيليات",
        Periodontist: "اختصاصي أمراض اللثة",
        Pathologist: "طبيب تشريح مرضي",
        Teacher: "مدرس",
        Pediatrician: "طبيب أطفال",
        "Plastic surgeon": "جراح تجميل",
        Proctologist: "أخصائي أمراض الشرج والمستقيم",
        "Occupational pathologist": "اختصاصي أمراض مهنية",
        Psychiatrist: "طبيب نفسي",
        "Psychiatrist-narcologist": "طبيب نفسي مختص بالإدمان",
        Psychologist: "أخصائي نفسي",
        Psychotherapist: "معالج نفسي",
        Pulmonologist: "طبيب أمراض صدرية",
        Radiolog: "أخصائي أشعة",
        Rehabilitologist: "اختصاصي تأهيل",
        Reanimatologist: "طبيب إنعاش",
        Rheumatologist: "طبيب أمراض روماتيزمية",
        Radiologist: "طبيب أشعة",
        "Reproductologist (IVF)": "اختصاصي التخصيب الاصطناعي",
        Reflexologist: "اختصاصي العلاج الانعكاسي",
        Sexologist: "أخصائي جنسي",
        "Cardiovascular surgeon": "جراح قلب وأوعية دموية",
        Somnologist: "أخصائي نوم",
        Dentist: "طبيب أسنان",
        "Childrens-dentist": "طبيب أسنان أطفال",
        "Dental hygienist": "أخصائي صحة الفم والأسنان",
        "Dentist-implantologist": "طبيب زراعة أسنان",
        "Dentist-orthodontist": "طبيب تقويم أسنان",
        "Orthopedic dentist": "طبيب أسنان تقويمي",
        "Dentist-therapist": "طبيب أسنان علاجي",
        "Dental surgeon": "جراح أسنان",
        Surdolog: "اختصاصي السمع",
        Therapist: "طبيب باطني",
        Toxicologist: "طبيب سموم",
        Traumatologist: "طبيب إصابات",
        "Traumatologist-orthopedist": "جراح إصابات وتقويم",
        Transplantologist: "جراح زراعة أعضاء",
        Transfusiologist: "اختصاصي نقل دم",
        Trichologist: "أخصائي الشعر",
        Urologist: "طبيب مسالك بولية",
        Pharmacist: "صيدلي",
        Paramedic: "مسعف",
        Physiotherapist: "معالج فيزيائي",
        Phlebologist: "طبيب أوردة",
        Phoniatrist: "أخصائي النطق والصوت",
        Phthisiatrician: "طبيب سل",
        Surgeon: "جراح",
        "Implant surgeon": "جراح زرع",
        "Maxillofacial surgeon": "جراح فك ووجه",
        Embryologist: "أخصائي أجنة",
        Endocrinologist: "طبيب غدد",
        Endoscopist: "طبيب مناظير",
        Epidemiologist: "طبيب وبائيات",
        Epileptologist: "طبيب صرع",
      },
    },
  },
};
